<template>
    <div>
        <!-- HEADER FOR ALL CLUSTERS -->
        <h1>Information Management Summit</h1>
        <h4>IM Summit is the organization’s flagship event that intends to showcase the primary roles of information technology and information management in a business or enterprise setting. This completely online-based business case competition brings the best and brightest undergraduate students all around the country together and pushes them to be innovative and tech-driven in facing real-world company problems. This online event will be held in a series of several days within 2-3 weeks in either  March or April of 2021. As this will be the first time for MISA’s flagship event to be conducted completely online, the Events Cluster will need competent, resourceful, and creative individuals who are capable of organizing and conducting the annual IM Summit.</h4>

        <!-- POSITIONS -->
        <h3>Positions:</h3>

        <!-- POSITION -->
        <h2><b>Promotional Strategist</b></h2>
        <ul>
            <li>Conceptualizes promotional strategy and timeline</li>
            <li>Handles the scheduling of the blasts and execution of promotional materials</li>
            <li>Oversees non-traditional promotions (and video/photo shoots once onsite classes are back)</li>
            <li>Communicates with Creative Directors for needed promotional materials</li>
            <li>Assists the AVP in compiling individual promotional timelines into the promotional calendar</li>
            <li>Sending Blast Requests through the Communications Cluster Blast Request Form</li>
            <li>Administers brainstorming sessions of the events they are deployed to with the supervision of the AVP for Promotional Strategy</li>
            <li>Utilizes selected social media channels of the organization</li>
        </ul>

        <!-- POSITION -->
        <h2><b>Video Editor</b></h2>
        <ul>
            <li>Edits videos of recordings made for events</li>
            <li>Updates the AVP for Creatives and Publications regarding changes made, and later submits video for approval</li>
            <li>Can be deployed to events or activities that require video promotions, or event videos</li>
            <li>Generates quality videos that will be blasted through the organization’s channels (e, g, Vimeo, Facebook, etc.)</li>
            <li>Required to upload all raw and post-processed videos and materials to the official Communications drive assigned to their event for archival and documentation purposes</li>
            <li>NOTE: While online classes are going on, officers who apply to be videographers will be’ responsible in collating all previously taken videos (both post-processed and raw footage)  for previous events and archive them properly for future uses for promotions</li>
        </ul>

        <h2><b>Human Resources Project Manager</b></h2>
        <ul>
            <li>Human Resources Officers deployed in various MISA projects and events and are tasked to handle the internal relationship of core team members</li>
            <li>Initiate ways in which core team members can bond and develop rapport (e.g. group dynamics and team building</li>
            <li>Conduct individual consultations with their core team members</li>
            <li>Relays messages to and from the HR Board to the Core Team</li>
            <li>In-charge of internal conflict management and resolution</li>
            <li>Conduct post-event core team evaluations with the HR Performance Management System</li>
        
        </ul>

    </div>
</template>

<script>
export default {
    name: 'PrimerOET'
}
</script>

<style scoped>
h1{
    font-size: 4.5vw;
}
</style>


